module.exports = __webpack_public_path__ + "static/staff-8-662bb75f85033501358c841c0a2cfc24.png";